// src/types/tax.ts - Types pour la gestion de la TVA

export interface TaxRate {
    id: string;
    name: string;
    rate: number;          // Taux en pourcentage (ex: 19.25 pour 19.25%)
    description?: string;
    isDefault: boolean;
    isActive: boolean;
    createdAt: Date;
    updatedAt?: Date;
  }
  
  export interface TaxConfiguration {
    defaultRateId: string;           // ID du taux par défaut
    rates: TaxRate[];               // Liste des taux disponibles
    displayMode: 'inclusive' | 'exclusive';  // Prix TTC ou HT
    showTaxOnReceipts: boolean;     // Afficher détail TVA sur tickets
    companyTaxNumber?: string;      // Numéro TVA de l'entreprise
  }
  
  // Calculs TVA
  export interface TaxCalculation {
    originalAmount: number;    // Montant de base
    taxRate: number;          // Taux appliqué
    taxAmount: number;        // Montant de la TVA
    amountExcludingTax: number;  // Montant HT
    amountIncludingTax: number;  // Montant TTC
  }
  
  // Détail TVA par taux (pour tickets et rapports)
  export interface TaxSummary {
    taxRateId: string;
    taxRateName: string;
    rate: number;
    baseAmount: number;       // Total HT pour ce taux
    taxAmount: number;        // Total TVA pour ce taux
    totalAmount: number;      // Total TTC pour ce taux
  }
  
  // Types pour les calculs
  export type TaxMode = 'inclusive' | 'exclusive';
  
  // Taux prédéfinis pour l'Afrique
  export const PREDEFINED_TAX_RATES: Omit<TaxRate, 'id' | 'createdAt' | 'updatedAt'>[] = [
    {
      name: 'TVA Standard Cameroun',
      rate: 19.25,
      description: 'Taux normal de TVA au Cameroun',
      isDefault: true,
      isActive: true,
    },
    {
      name: 'TVA Sénégal',
      rate: 18,
      description: 'Taux normal de TVA au Sénégal',
      isDefault: false,
      isActive: true,
    },
    {
      name: 'TVA Côte d\'Ivoire',
      rate: 20,
      description: 'Taux normal de TVA en Côte d\'Ivoire',
      isDefault: false,
      isActive: true,
    },
    {
      name: 'TVA Burkina Faso',
      rate: 18,
      description: 'Taux normal de TVA au Burkina Faso',
      isDefault: false,
      isActive: true,
    },
    {
      name: 'TVA Mali',
      rate: 18,
      description: 'Taux normal de TVA au Mali',
      isDefault: false,
      isActive: true,
    },
    {
      name: 'Exonéré',
      rate: 0,
      description: 'Produits/services exonérés de TVA',
      isDefault: false,
      isActive: true,
    },
  ];
  
  // Configuration par défaut pour nouveaux business
  export const DEFAULT_TAX_CONFIGURATION: TaxConfiguration = {
    defaultRateId: 'cameroon_standard', // Sera généré lors de la création
    rates: [], // Sera populé lors de la création du business
    displayMode: 'inclusive', // Prix TTC par défaut (plus simple pour les commerces)
    showTaxOnReceipts: true,
    companyTaxNumber: undefined,
  };